function ConversionIcon({color = '#000'}: { color?: string }) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
            stroke={color} strokeLinecap="round" strokeLinejoin="round">
            <g clipPath="url(#clip0_39337_17489)">
                <path d="M16.5039 2H19.5039V5" />
                <path d="M1 9L5.317 5.981C5.50952 5.84633 5.74331 5.78374 5.97737 5.80422C6.21142 5.8247 6.43079 5.92694 6.597 6.093L6.905 6.401C7.07232 6.56835 7.29356 6.67094 7.52939 6.69053C7.76522 6.71013 8.00036 6.64545 8.193 6.508L10.393 4.94C10.57 4.81355 10.7834 4.74826 11.0009 4.75403C11.2183 4.7598 11.428 4.83633 11.598 4.972L12.898 6.016C13.0712 6.15456 13.2855 6.23162 13.5072 6.23506C13.729 6.2385 13.9456 6.16812 14.123 6.035L19.5 2" />
                <path d="M4.5 18.5C4.5 18.3674 4.44732 18.2402 4.35355 18.1464C4.25979 18.0527 4.13261 18 4 18H2C1.86739 18 1.74021 18.0527 1.64645 18.1464C1.55268 18.2402 1.5 18.3674 1.5 18.5V22H4.5V18.5Z" />
                <path d="M10.5 13.5C10.5 13.3674 10.4473 13.2402 10.3536 13.1464C10.2598 13.0527 10.1326 13 10 13H8C7.86739 13 7.74021 13.0527 7.64645 13.1464C7.55268 13.2402 7.5 13.3674 7.5 13.5V22H10.5V13.5Z" />
                <path d="M16.5 16.5C16.5 16.3674 16.4473 16.2402 16.3536 16.1464C16.2598 16.0527 16.1326 16 16 16H14C13.8674 16 13.7402 16.0527 13.6464 16.1464C13.5527 16.2402 13.5 16.3674 13.5 16.5V22H16.5V16.5Z" />
                <path d="M22.5 8.5C22.5 8.36739 22.4473 8.24021 22.3536 8.14645C22.2598 8.05268 22.1326 8 22 8H20C19.8674 8 19.7402 8.05268 19.6464 8.14645C19.5527 8.24021 19.5 8.36739 19.5 8.5V22H22.5V8.5Z" />
                <path d="M0.503906 22H23.5039" />
            </g>
            <defs>
                <clipPath id="clip0_39337_17489">
                    <rect width="24" height="24" fill="#fff" />
                </clipPath>
            </defs>
        </svg>
    );
}

export default ConversionIcon;
